var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2WomenShower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 19.94V72h-4V19.94c0-9.1-6.09-12.75-11.31-13.12-4.29-.29-8.92 1.54-11 5.53A8 8 0 0140.51 20h-16a8 8 0 015.85-7.65c2.3-6.79 9.23-9.94 15.6-9.49 7.49.52 15.04 6 15.04 17.08zM42.38 38.11a6.51 6.51 0 00-6.62-5h-7.52a6.51 6.51 0 00-6.61 5L19 49.53a2 2 0 001.51 2.39c.16.044.324.071.49.08a2 2 0 002-1.56l2.6-11.47a2.46 2.46 0 012.36-1.83L24.14 56H27v14a2 2 0 104 0V56h2v14a2 2 0 104 0V56h2.86l-3.75-18.89A2.459 2.459 0 0138.47 39l2.6 11.46A2 2 0 0043 52c.146.014.294.014.44 0A1.998 1.998 0 0045 49.53l-2.62-11.42zM34.44 30a3.93 3.93 0 10-4.899-6.146A3.93 3.93 0 0034.44 30z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Women_shower.860ae42d.svg";
export { SvgE2WomenShower as ReactComponent };